import firebase from 'firebase/app';
import 'firebase/firebase-messaging';

var firebaseConfig = {
  apiKey: "AIzaSyB6AoQOv1z-5dRylySHUM2MuVKT6mc5_dg",
  authDomain: "tamayoz-core.firebaseapp.com",
  projectId: "tamayoz-core",
  storageBucket: "tamayoz-core.appspot.com",
  messagingSenderId: "865191792765",
  appId: "1:865191792765:web:01c2aa1fc921eae673a114",
  measurementId: "G-47EWE2XE7N"
};

firebase.initializeApp(firebaseConfig);
const vapidKey = 'BMbJWx-0wuVR0o2uVpwoxHUe-07EDmrreOZa6mJ7IZhd6OKBZTFILET7IMfrY42l7b90w7gmRMnyKP7mJjhDFs0';

// Safari on iOS does not expose Notification/PushManager in a normal browser tab,
// so firebase.messaging() throws `messaging/unsupported-browser` there. This module
// is imported by the entry (main.ts), so throwing here aborts the whole bundle before
// $mount('#app') runs and the initial #loading-bg spinner never goes away.
// Degrade to null instead; every $messaging call site guards against it.
function createMessaging() {
  try {
    if (typeof firebase.messaging.isSupported !== 'function' || firebase.messaging.isSupported()) {
      return firebase.messaging();
    }
  } catch (error) {
    return null;
  }
  return null;
}

const messaging = createMessaging();
const isMessagingSupported = messaging !== null;

export default messaging;
export {vapidKey, isMessagingSupported};
